import { render, staticRenderFns } from "./ApproveCancelServicesReservation.vue?vue&type=template&id=76f41a05&scoped=true&"
import script from "./ApproveCancelServicesReservation.vue?vue&type=script&lang=js&"
export * from "./ApproveCancelServicesReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f41a05",
  null
  
)

export default component.exports